import type { CmsProduct } from '../types/cmsProduct';
import type {
  ComponentProductMetadata,
  MetadataProductCard,
} from '../types/cmsTypes';

/**
 * A card switched off (`visible: false`) renders nowhere, so it does not count;
 * the early return keeps a uid-less product from matching a uid-less card.
 */
export const findMetadataProductCard = (
  productMetaConfig: ComponentProductMetadata | undefined,
  product: CmsProduct | undefined,
): MetadataProductCard | undefined => {
  const uid = product?.uid;

  if (!uid) {
    return undefined;
  }

  return productMetaConfig?.product_card?.find(
    (card) => card.visible !== false && card.productBlock?.product?.uid === uid,
  );
};
